module.exports = __webpack_public_path__ + "img/ground4.3cbb5762.png";